<template>
  <vs-card>
    <div class="vx-row p-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <div class="vx-col w-1/2 mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|min:2'"
                v-model="form.name"
                label="Name *"
                name="name"
                placeholder="Full name"
                data-vv-as="Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>

            <div class="vx-col w-1/2 mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|min:2'"
                v-model="form.designation"
                label="Designation *"
                name="designation"
                placeholder="e.g. Founder & CEO"
                data-vv-as="Designation"
              />
              <span class="text-danger text-sm" v-show="errors.has('designation')">{{
                errors.first('designation')
              }}</span>
            </div>

            <div class="vx-col w-1/2 mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|min:2'"
                v-model="form.role"
                label="Role Group *"
                name="role"
                placeholder="e.g. Founders, Advisors, Board"
                data-vv-as="Role"
              />
              <span class="text-danger text-sm" v-show="errors.has('role')">{{ errors.first('role') }}</span>
              <p class="text-xs text-grey mt-1">Website groups leaders under this role heading.</p>
            </div>

            <div class="vx-col w-1/2 mb-2">
              <vs-input
                class="w-full"
                v-validate="'numeric|min_value:0'"
                v-model="form.sort_order"
                type="number"
                label="Sort Order"
                name="sort_order"
                placeholder="0"
                data-vv-as="Sort Order"
              />
              <span class="text-danger text-sm" v-show="errors.has('sort_order')">{{
                errors.first('sort_order')
              }}</span>
            </div>

            <div class="vx-col w-1/2 cursor-pointer">
              <label class="vs-input--label block">Photo *</label>
              <input
                :key="fileKey"
                type="file"
                class="border p-2 rounded w-full"
                ref="files"
                accept=".jpg, .png, .jpeg"
                @change="handleFileUpload"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                data-vv-as="Image"
              />
              <input type="hidden" name="image" v-model="form.image" v-validate="imagevalidationRule" data-vv-as="Image" />
              <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
              <div class="mt-5">
                <div class="relative" v-if="preview_image">
                  <div class="h-64 w-64 mt-5 overflow-hidden">
                    <img height="200px" width="250px" :src="preview_image" alt="Image Preview" class="object-fit" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" id="create-leadership" @click="save_changes">
                  {{ $route.params.id ? 'Update' : 'Add' }}
                </vs-button>
                <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <div class="modal__content w-full h-full">
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper
                  ref="cropper"
                  name="Image"
                  class="cropper-image"
                  :src="crop_image.src"
                  :aspectRatio="3 / 4"
                  :initialAspectRatio="3 / 4"
                />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">
                  Crop Image
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </vs-card>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'AddUpdateLeadership',
  components: { Cropper },
  data() {
    return {
      fileKey: 0,
      breadcrumb: [],
      form: {
        name: null,
        designation: null,
        role: null,
        sort_order: 0,
        image: null
      },
      preview_image: null,
      crop_image: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenImageCrop: false
    }
  },
  computed: {
    ...mapState('leadership', ['createLoading']),
    imagevalidationRule() {
      return !this.$route.params.id ? 'required' : ''
    }
  },
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('leadership/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Our Leadership', url: '/leadership/list' },
          { title: `Edit ${data.name}`, active: true }
        ]
        this.form.name = data.name
        this.form.designation = data.designation
        this.form.role = data.role
        this.form.sort_order = data.sort_order != null ? data.sort_order : 0
        this.preview_image = data.image ? data.image : null
      })
    }
  },
  methods: {
    ...mapActions('leadership', {
      create: 'create',
      update: 'update'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.$route.params.id && !this.form.image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Photo is required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (this.form[key] !== null && this.form[key] !== undefined && this.form[key] !== '') {
            data.append(key, this.form[key])
          }
        }
        if (this.form.sort_order === 0 || this.form.sort_order === '0') {
          data.set('sort_order', this.form.sort_order)
        }
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        } else {
          response = await this.create(data)
        }
        this.$router.push({ name: 'leadership-list' })
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'leadership-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },
    handleFileUpload(e) {
      const file = e.target.files[0]
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!file) return
      if (!allowedTypes.includes(file.type)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Only JPG, PNG, and JPEG images are allowed.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const blob = URL.createObjectURL(file)
      this.crop_image = { src: blob, type: file.type }
      this.IsOpenImageCrop = true
      this.fileKey++
    },
    cropImage() {
      const result = this.$refs.cropper.getResult()
      if (result.canvas == undefined) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Image',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const resultTest = result.canvas.toDataURL(this.crop_image.type)
      const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '')
      this.b64toBlob(base64Image, this.crop_image.type)
      this.IsOpenImageCrop = false
    },
    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      const blob = new File(byteArrays, 'image.jpg', { type: contentType })
      this.form.image = blob
      this.preview_image = URL.createObjectURL(blob)
      return blob
    }
  },
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-leadership',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-leadership > .con-vs-loading')
      }
    }
  }
}
</script>

<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
</style>
